<section class="section-white introduction" id='introduction'>
  <div class="row w-100 mx-0 py-5 px-md-5 px-4 d-flex justify-content-center h-100 text-center" data-aos="fade-up" data-aos-duration="1000">
      <h2 class="mb-0">{{ 'Introduction.title' | translate | uppercase }}</h2>
  </div>
</section>
